import { AssignmentPageConfig } from "./assignment/AssignmentPageConfig";
import { ConnectKonjPageConfig } from "./connectKonj/ConnectKonjPageConfig";
import { OnlineExamPageConfig } from "./online-exam/OnlineExamPageConfig";
import { ProfilePageConfig } from "./profile/ProfilePageConfig";
import { ReportsPageConfig } from "./report/ReportPageConfig";
import { AdminPageConfig } from "./admin/AdminPageConfig";

export const mainConfig = [
  OnlineExamPageConfig,
  AssignmentPageConfig,
  ConnectKonjPageConfig,
  ReportsPageConfig,
  ProfilePageConfig,
  AdminPageConfig,
];
